// apolloClient.ts
import { ApolloClient, ApolloLink, from, InMemoryCache } from '@apollo/client';

import {
  AdminHttpLink,
  authLink,
  CustomerHttpLink,
  errorLink,
} from './authMiddleware';

export enum Endpoint {
  admin = 'admin',
  customer = 'customer',
}

const adminLink = from([authLink, errorLink, AdminHttpLink]);
const customerLink = from([authLink, errorLink, CustomerHttpLink]);

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.split(
    (operation) => operation.getContext().version === Endpoint.customer,
    customerLink,
    adminLink,
  ),
});
